import { Rows3, Sparkles } from "lucide-react";
import { HeaderToolButton } from "@/components/layout/shell";
import { cn } from "@/lib/utils";
import { useWorkbench } from "./workbench-provider";

interface WorkbenchHeaderControlsProps {
  className?: string;
  tone?: "default" | "on-dark";
}

export function WorkbenchHeaderControls({
  className,
  tone = "default",
}: WorkbenchHeaderControlsProps) {
  const { showTabs, toggleTabs, copilotEnabled, toggleCopilot } = useWorkbench();
  const onDark = tone === "on-dark";

  return (
    <div
      className={cn(
        "flex items-center gap-1.5 sm:gap-2",
        onDark &&
          "[&_button]:border-white/15 [&_button]:bg-white/10 [&_button]:text-white [&_button]:ring-white/20 [&_button]:hover:bg-white/15 [&_button[data-variant=active]]:bg-white/20 [&_button[data-variant=primary]]:bg-white/15 [&_button[data-variant=primary]]:text-white [&_button[data-variant=amber]]:bg-amber-500/90 [&_button[data-variant=amber]]:text-white",
        className,
      )}
    >
      <HeaderToolButton
        title={showTabs ? "Hide tab bar" : "Show tab bar"}
        variant={showTabs ? "active" : "default"}
        data-variant={showTabs ? "active" : "default"}
        onClick={toggleTabs}
      >
        <Rows3 className="h-5 w-5" />
      </HeaderToolButton>

      <HeaderToolButton
        title={copilotEnabled ? "Turn off AI Copilot" : "Turn on AI Copilot"}
        variant={copilotEnabled ? "amber" : "default"}
        data-variant={copilotEnabled ? "amber" : "default"}
        className={cn(!copilotEnabled && !onDark && "hover:text-amber-600 hover:ring-amber-300/40")}
        onClick={toggleCopilot}
      >
        <Sparkles className="h-5 w-5" />
      </HeaderToolButton>
    </div>
  );
}
